import React, { useEffect } from "react";
import Layout from "../layout/AppLayout";
import SessionManager from "../auth/sessionmanager";
import { Col, Row, Typography, Card } from "antd";
import realIcon from "../../assets/img/Real-time-icon.png";
import increasedIcon from "../../assets/img/Increased-Resilience-icon.png";
import decisionIcon from "../../assets/img/Decision-Support-icon.png";
import carbonIcon from "../../assets/img/Carbon-Footprint-icon.png";
import homepic from "../../assets/img/MARCIN_1.JPG";
import thirdSectionPic from "../../assets/img/BUSINE_1.JPG";

const { Paragraph } = Typography;

const Home = () => {
  const email = SessionManager.getUserName();
  const username = email.split("@")[0];

  // Add styles to document head
  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.textContent = `
      * {
        scroll-behavior: smooth !important;
      }
      
      ::-webkit-scrollbar {
        width: 8px;
      }
      
      ::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
      }
      
      ::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
      }
      
      ::-webkit-scrollbar-thumb:hover {
        background: #555;
      }

      @keyframes scroll-wheel {
        0% {
          top: 6px;
          opacity: 1;
        }
        50% {
          top: 18px;
          opacity: 0.5;
        }
        100% {
          top: 6px;
          opacity: 1;
        }
      }

      @keyframes bounce {
        0%, 20%, 50%, 80%, 100% {
          transform: translateY(0);
        }
        40% {
          transform: translateY(-5px);
        }
        60% {
          transform: translateY(-3px);
        }
      }

      .scroll-indicator:hover .scroll-mouse {
        border-color: #F9B31B;
      }

      .scroll-indicator:hover .scroll-wheel {
        background-color: #F9B31B;
      }

      .scroll-indicator:hover .scroll-text {
        color: #F9B31B;
      }

      /* Responsive styles */
      @media (max-width: 768px) {
        .hero-title {
          font-size: 1.8rem !important;
        }
        
        .hero-subtitle {
          font-size: 1.2rem !important;
        }
        
        .section-title {
          font-size: 1.5rem !important;
        }
        
        .section-text {
          font-size: 1rem !important;
        }
        
        .card-text {
          font-size: 12px !important;
        }
        
        .platform-box {
          width: 250px !important;
          height: 250px !important;
          font-size: 1.2rem !important;
        }
      }

      @media (max-width: 576px) {
        .hero-title {
          font-size: 1.5rem !important;
        }
        
        .hero-subtitle {
          font-size: 1rem !important;
        }
        
        .section-title {
          font-size: 1.3rem !important;
        }
        
        .section-text {
          font-size: 0.9rem !important;
        }
        
        .card-text {
          font-size: 11px !important;
        }
        
        .platform-box {
          width: 200px !important;
          height: 200px !important;
          font-size: 1rem !important;
        }
        
        .card-container {
          padding: 12px !important;
        }
      }
    `;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  const getCardStyle = () => ({
    width: "100%",
    height: window.innerWidth <= 576 ? "130px" : window.innerWidth <= 768 ? "140px" : "150px",
    marginBottom: 10,
    background: "#e7a310ff",
    display: "flex",
    alignItems: "center",
    padding: window.innerWidth <= 576 ? "12px" : "16px",    
  });

  const getHeroSectionStyle = () => ({
    backgroundImage: `url(${homepic})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: window.innerWidth <= 768 ? "70vh" : "80vh",
    display: "flex",
    flexDirection: "column",
    //justifyContent: "center",
    alignItems: "flex-start",
    padding: window.innerWidth <= 576 ? "0px 16px" : "30px 30px",
    position: "relative",
   //margin: window.innerWidth <= 576 ? "0px 4px" : "0px 8px",
    clipPath: "polygon(0 0, 100% 0, 100% 80%, 0% 100%)",
  });

  const overlayStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    zIndex: 1,
  };

  const textStyle = {
    position: "relative",
    zIndex: 2,
    color: "white",
    textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)",
  };

  const getSectionStyle = () => ({
    minHeight: window.innerWidth <= 768 ? "auto" : "70vh",
    display: "flex",
    alignItems: "center",
    padding: window.innerWidth <= 576 ? "20px 4px" : window.innerWidth <= 768 ? "30px 8px" : "40px 8px",
    scrollSnapAlign: "start",
    scrollSnapStop: "always",
  });

  const getContainerStyle = () => ({
    height: window.innerWidth <= 768 ? "auto" : "80vh",
    overflowY: window.innerWidth <= 768 ? "visible" : "auto",
    scrollSnapType: window.innerWidth <= 768 ? "none" : "y mandatory",
    scrollBehavior: "smooth",
  });

  const scrollIndicatorStyle = {
    position: "absolute",
    bottom: "15%",
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 3,
    display: window.innerWidth <= 768 ? "none" : "flex",
    flexDirection: "column",
    alignItems: "center",
    cursor: "pointer",
  };

  const scrollMouseStyle = {
    width: "24px",
    height: "40px",
    border: "2px solid white",
    borderRadius: "12px",
    position: "relative",
    marginBottom: "8px",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(10px)",
  };

  const scrollWheelStyle = {
    width: "2px",
    height: "8px",
    backgroundColor: "white",
    borderRadius: "1px",
    position: "absolute",
    top: "6px",
    left: "50%",
    transform: "translateX(-50%)",
    animation: "scroll-wheel 2s infinite",
  };

  const scrollTextStyle = {
    color: "white",
    fontSize: "12px",
    fontWeight: "500",
    textShadow: "1px 1px 2px rgba(0, 0, 0, 0.7)",
    animation: "bounce 2s infinite",
  };

  const handleScrollDown = () => {
    const container = document.querySelector("[data-scroll-container]");
    if (container) {
      container.scrollTo({
        top: container.scrollHeight / 3,
        behavior: "smooth",
      });
    }
  };


  return (
    <Layout>
      <div style={getContainerStyle()} data-scroll-container>
        {/* Hero Section with Background Image */}
        <div
          style={{
            ...getHeroSectionStyle(),
            scrollSnapAlign: "start",
            scrollSnapStop: "always",
          }}
        >
          <div style={overlayStyle}></div>
          <h2
            className="hero-title"
            style={{
              ...textStyle,
              display: "flex",
              justifyContent: "left",
              fontSize: "2.5rem",
              margin: "0",
            }}
          >
            Welcome Back, {username}
          </h2>
          <h4
            className="hero-subtitle"
            style={{
              ...textStyle,
              fontSize: "1.5rem",
              margin: "10px 0 0 0",
            }}
          >
            Home
          </h4>

          {/* Scroll Indicator */}
          <div style={scrollIndicatorStyle} className="scroll-indicator" onClick={handleScrollDown}>
            <div style={scrollMouseStyle} className="scroll-mouse">
              <div style={scrollWheelStyle} className="scroll-wheel"></div>
            </div>
            <div style={scrollTextStyle} className="scroll-text">
              Scroll to explore
            </div>
          </div>
        </div>

        {/* First Section - Overall Concept */}
        <div style={getSectionStyle()}>
          <div style={{ width: "100%", maxWidth: "1200px", margin: "0 auto" }}>
            <Row gutter={[24, 24]} style={{ height: "100%" }}>
              {/* Left Section - Text Content */}
              <Col xs={24} sm={4} md={24} lg={24} xl={12}>
                <div
                  style={{
                    paddingRight: window.innerWidth <= 768 ? "10px" : "20px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    height: "100%",
                    marginBottom: window.innerWidth <= 768 ? "20px" : "0",
                  }}
                >
                  <h3
                    className="section-title"
                    style={{
                      color: "#142745",
                      marginBottom: "24px",
                      fontSize: "2rem",
                    }}
                  >
                    Overall Concept
                  </h3>
                  <p
                    className="section-text"
                    style={{
                      textAlign: "justify",
                      lineHeight: "1.8",
                      fontSize: "1.1rem",
                      color: "#333",
                    }}
                  >
                    The FOR-FREIGHT (Flexible, multi-mOdal and Robust FREIGHt Transport) project aims to maximise the
                    utilisation of multimodal freight transport capacity, achieve competitive sustainability with higher
                    levels of efficiency, and reduce the average cost of freight transport through the development of
                    novel solutions and their integration with legacy logistics systems. This will enable more effective
                    and sustainable management of goods and freight flows in airports, ports, inland terminals and
                    various logistics nodes, taking into account the requirements of all involved stakeholders, and
                    accounting for economic, environmental and social aspects. The FOR-FREIGHT solutions will target the
                    end-to-end optimization of multimodal/multi-stakeholder logistics processes and improved access to
                    transshipment services through the following Unique Value Propositions:
                  </p>
                </div>
              </Col>

              {/* Right Section - Cards */}
              <Col xs={24} sm={4} md={24} lg={24} xl={12}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <Card style={getCardStyle()}>
                    <div style={{ display: "flex", alignItems: "center", gap: "15px", width: "100%" }}>
                      <img
                        src={realIcon}
                        alt=""
                        style={{
                          width: window.innerWidth <= 576 ? "40px" : "50px",
                          height: window.innerWidth <= 576 ? "40px" : "50px",
                          flexShrink: 0,
                        }}
                      />
                      <Paragraph className="card-text" style={{ margin: 0, fontSize: "14px", flex: 1  }}>
                        <strong>Real-time, Door-to-Door Tracking:</strong>
                        <span style={{ display: 'block' , color: 'white' }}>Real-time, door-to-door tracking across
                        stakeholders' domains and management systems (elimination of information silos) with global
                        geo-location and status monitoring & control of Intermodal Transport Units (ITUs).</span>
                      </Paragraph>
                    </div>
                  </Card>

                  <Card style={getCardStyle()}>
                    <div style={{ display: "flex", alignItems: "center", gap: "15px", width: "100%" }}>
                      <img
                        src={decisionIcon}
                        alt=""
                        style={{
                          width: window.innerWidth <= 576 ? "40px" : "50px",
                          height: window.innerWidth <= 576 ? "40px" : "50px",
                          flexShrink: 0,
                        }}
                      />
                      <Paragraph className="card-text" style={{ margin: 0, fontSize: "14px", flex: 1 }}>
                        <strong>Decision Support Systems (DSS):</strong> 
                        <span style={{ display: 'block' , color: 'white' }}> Decision Support Systems (DSS) for the
                        optimization of resource utilization (labour, vehicles, equipment) using advanced Artificial
                        Intelligence (AI)/Machine Learning (ML) techniques and Digital Twin concepts.</span>
                      </Paragraph>
                    </div>
                  </Card>

                  <Card style={getCardStyle()}>
                    <div style={{ display: "flex", alignItems: "center", gap: "15px", width: "100%" }}>
                      <img
                        src={increasedIcon}
                        alt=""
                        style={{
                          width: window.innerWidth <= 576 ? "40px" : "50px",
                          height: window.innerWidth <= 576 ? "40px" : "50px",
                          flexShrink: 0,
                        }}
                      />
                      <Paragraph className="card-text" style={{ margin: 0, fontSize: "14px", flex: 1 }}>
                        <strong>Increased Resilience & Security:</strong> 
                        <span style={{ display: 'block' , color: 'white' }}>Increased resilience of the multimodal
                        logistics chain against large-scale disruptive events (e.g., pandemic), based on proactive
                        planning, heterogeneous data analytics, etc., and increased security of information exchange
                        based on Blockchain technology.</span>
                      </Paragraph>
                    </div>
                  </Card>

                  <Card style={getCardStyle()}>
                    <div style={{ display: "flex", alignItems: "center", gap: "15px", width: "100%" }}>
                      <img
                        src={carbonIcon}
                        alt=""
                        style={{
                          width: window.innerWidth <= 576 ? "40px" : "50px",
                          height: window.innerWidth <= 576 ? "40px" : "50px",
                          flexShrink: 0,
                        }}
                      />
                      <Paragraph className="card-text" style={{ margin: 0, fontSize: "14px", flex: 1 }}>
                        <strong>Carbon Footprint Assessment & Transport Networks:</strong>
                        <span style={{ display: 'block' , color: 'white' }}> Increased sector
                        sustainability through the adoption of a carbon footprint assessment framework and the
                        utilization of public transport networks (e.g., subway) leading to reduced GHG emissions.</span>
                      </Paragraph>
                    </div>
                  </Card>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        {/* Second Section - FOR-FREIGHT Methodology */}
        <div style={getSectionStyle()}>
          <div style={{ width: "100%", maxWidth: "1200px", margin: "0 auto" }}>
            <Row gutter={[24, 24]} style={{ height: "100%" }}>
              {/* Left Section - Platform Box */}
              <Col xs={24} sm={4} md={24} lg={24} xl={12}>
                <div
                  style={{
                    paddingRight: window.innerWidth <= 768 ? "10px" : "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    marginTop: window.innerWidth <= 768 ? "20px" : "0",
                  }}
                >
                  <img style={{width:'90%' , height:'590px', borderRadius:'15px' ,  backgroundSize: "cover",}} alt="" src={thirdSectionPic}></img>
                </div>
              </Col>

              {/* Right Section - FOR-FREIGHT Methodology */}
             <Col xs={24} sm={4} md={24} lg={24} xl={12}>
                <div
                  style={{
                    paddingLeft: window.innerWidth <= 768 ? "10px" : "20px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <h3
                    className="section-title"
                    style={{
                      color: "#142745",
                      marginBottom: "10px",
                      fontSize: "2rem",
                    }}
                  >
                    FOR-FREIGHT Methodology
                  </h3>
                  <p
                    className="section-text"
                    style={{
                      textAlign: "justify",
                      lineHeight: "1.8",
                      marginBottom: "20px",
                      fontSize: "1.1rem",
                      color: "#333",
                    }}
                  >
                    The methodology of FOR-FREIGHT is structured in the following key directions:
                  </p>
                  <ul
                    style={{
                      lineHeight: "1.8",
                      paddingLeft: "20px",
                      marginBottom: "20px",
                      fontSize: window.innerWidth <= 768 ? "0.9rem" : "1rem",
                      color: "#555",
                    }}
                  >
                    <li>The creation of three multimodal T&L trial sites in operational environments.</li>
                    <li>
                      The integration of the functionality of the three sites under a common cloud-based experimentation
                      platform, offering access, monitoring and evaluation capabilities.
                    </li>
                    <li>
                      The realization of extensive trials to test and validate the proposed multimodal logistics
                      services.
                    </li>
                    <li>
                      The creation of sustainable business models and development plans for collaborative, multimodal
                      T&L services.
                    </li>
                    <li>
                      The creation and evolution of a multimodal logistics ecosystem to promote the adoption of novel
                      FOR-FREIGHT solutions.
                    </li>
                  </ul>
                  <p
                    className="section-text"
                    style={{
                      textAlign: "justify",
                      lineHeight: "1.8",
                      fontSize: window.innerWidth <= 768 ? "0.9rem" : "1rem",
                      color: "#555",
                    }}
                  >
                    The project's use cases
                    (UCs) and real-life field trials will target three complementary intermodal transport scenarios,
                    namely seaport-to-city (last mile) with the use of the subway network, seaport-to-airport with the
                    use of trucks, and inland (river) port-to-mainland via rail transport, thus covering a broad
                    spectrum of relevant functionalities and accommodating the requirements of the majority of T&L
                    stakeholders.
                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Home;
